__turbopack_context__.v({
  "Burger": "Uz1p3q_Burger",
  "BurgerLineBottom": "Uz1p3q_BurgerLineBottom",
  "BurgerLineMiddle": "Uz1p3q_BurgerLineMiddle",
  "BurgerLineTop": "Uz1p3q_BurgerLineTop",
  "Closed": "Uz1p3q_Closed",
  "Force": "Uz1p3q_Force",
  "Open": "Uz1p3q_Open",
  "Root": "Uz1p3q_Root",
  "moveBottomLineAndRotate": "Uz1p3q_moveBottomLineAndRotate",
  "moveBottomLineAndRotateReverse": "Uz1p3q_moveBottomLineAndRotateReverse",
  "moveTopLineAndRotate": "Uz1p3q_moveTopLineAndRotate",
  "moveTopLineAndRotateReverse": "Uz1p3q_moveTopLineAndRotateReverse",
});
